/**
 * @callback TReturnsTranslate
 * @param key {string}
 * @param params {Record<string, unknown>}
 * @returns {Promise<import('./returns-api').TApiResult<import('./returns-api').TGetOrderResult>>}
 */

export default {
	install: ( app ) => {

		const { localization } = window.returnsConfiguration;

		/** @type TReturnsTranslate */
		const translate = ( key, params ) => {
			const translated = translateFromDictionary( localization, key, params );
			if ( !translated ) {
				console.warn( 'No translation found for key:', key );
				return key;
			}
			return translated;
		}

		app.provide( 'translate', translate )
	}
}

/**
 * @param dictionary {Record<string, unknown>}
 * @param key {string}
 * @param params {Record<string, unknown>}
 * @return {string | false} the translated string, if found; false otherwise
 */
function translateFromDictionary( dictionary, key, params ) {
	// const dictionary = returnsConfiguration.localization;
	// Convert key in dot-notation to the requested label
	const dictionaryValue = key.toLowerCase().split( '.' ).reduce( ( o, k ) => ( o ? o[ k ] : undefined ), dictionary )
	if ( !dictionaryValue )
		return false;
	const interpolatedValue = Object.entries( params ).reduce( ( current, [ paramKey, paramValue ] ) => {
		const regEx = new RegExp( "\\\$" + paramKey + "", 'gi' );
		return current.replaceAll( regEx, paramValue );
	}, dictionaryValue );
	return interpolatedValue;
}
